import { render, staticRenderFns } from "./popupRecord.vue?vue&type=template&id=60e97172&scoped=true"
import script from "./popupRecord.vue?vue&type=script&lang=js"
export * from "./popupRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e97172",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\dianlala_project\\电啦啦\\cd-vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60e97172')) {
      api.createRecord('60e97172', component.options)
    } else {
      api.reload('60e97172', component.options)
    }
    module.hot.accept("./popupRecord.vue?vue&type=template&id=60e97172&scoped=true", function () {
      api.rerender('60e97172', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/equipment/popupRecord.vue"
export default component.exports